<template>
    <div>

    </div>
</template>

<script>
    // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    // 例如：import 《组件名称》 from '《组件路径》';



    // est
    export default {
// import引入的组件需要注入到对象中才能使用
        components: {},
        props: [],
        data() {
          return {
            test: ''
          }
        },
// 监听属性 类似于data概念
        computed: {},
// 监控data中的数据变化
        watch: {},
// 生命周期 - 创建完成（可以访问当前this实例）
        created() {
                console.log('created')
        },
// 生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
                console.log('mounted')
        },
        beforeCreate() {
                console.log('beforeCreate')
        }, // 生命周期 - 创建之前
        beforeMount() {
                console.log('beforeMount')
        }, // 生命周期 - 挂载之前
        beforeUpdate() {
                console.log('beforeUpdate')
        }, // 生命周期 - 更新之前
        updated() {
                console.log('updated')
        }, // 生命周期 - 更新之后
        beforeDestroy() {
                console.log('beforeDestroy')
        }, // 生命周期 - 销毁之前
        destroyed() {
                console.log('destroyed')
        }, // 生命周期 - 销毁完成
        activated() {
                console.log('activated')
        },
// 方法集合
        methods: {}
    }
</script>
<style lang='scss' scoped>
    // @import url(); 引入公共css类
</style>
